// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__1Yi5b","current":"style_current__3NZPb","arrow":"style_arrow__2WNVO"};